export const TC_ACCESS_TOKEN = 'tc_access_token';
export const TC_SESSION_KEY = 'tc_session_key';
export const JWT_CUSTOM_GROUPS = 'custom:groups';
export const SKIP_AUTHENTICATION = process.env.REACT_APP_SKIP_AUTH === 'true';